import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { allowBroadcast } from 'features/permissions/actions';

export function* allowBroadcastSaga(action: ReturnType<typeof allowBroadcast>) {
  const { audio, video, id } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user allowed broadcast to user id=${id} with audio=${audio} and video=${video}`);

  yield call(SignalingSocket.send, {
    event: 'allowBroadcast',
    data: {
      id,
      audio,
      video,
    },
  });
}
